export const ContactEnums = {
  PHONE_NUMBER: '(844) 468-2473',
  EMAIL: 'support@scorebird.com',
};
